import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useReportDownload = ({
  enabled,
  report,
  fileFormat,
  startDateFilter,
  endDateFilter,
  branchFilter,
  typeFilter,
}) => {
  const reportFilter = {
    formatFilter: fileFormat,
    startDateFilter: startDateFilter,
    endDateFilter: endDateFilter,
    branchFilter: branchFilter,
    typeFilter: typeFilter,
  };
  return useQuery({
    enabled: enabled,
    queryKey: ["useReportDownload"],
    queryFn: async () =>
      callApi({
        path: "report",
        command: report,
        data: JSON.stringify({ data: { filter: reportFilter } }),
        download: true,
      }),
  });
};
